"use strict";
const pageId = document.body.id;

if (pageId === "law"){
    const menuToggle = document.querySelector(".menu__toggle");
    const menu = document.querySelector(".menu");
    

    const menuLinks= document.querySelectorAll(".menu__el a");

    if(menuToggle){
        menuToggle.addEventListener("click", menuOpen);

        for(let menuLink of menuLinks){
            menuLink.addEventListener("click", menuOpen);
        }
    }
    function menuOpen(){
        menu.classList.toggle("menu--open");
       // body.classList.toggle("no--scroll");

    }
        menu.classList.toggle("menu--open");

    //---------------------------------------------------

    const btnJs = document.querySelector(".btn-js");
    const greySection = document.querySelector(".fraudes-js");

    btnJs.addEventListener("click", function(){
        greySection.classList.add("greyanimation");
    });
   greySection.addEventListener("animationend", function(){
       greySection.classList.remove("greyanimation")
   });

    //----------------------------------------------------
    const btn = document.querySelector(".law-btn-js");
    const arrow = document.querySelector(".law-btn__arrow");

    const container = document.querySelector(".law-container");

    const paragraphe = document.querySelector(".law-noarticle");

    btn.addEventListener("click", function(){
        container.classList.toggle("close");
        arrow.classList.toggle("turn");
    });

    //dark mode
    const titreDark = document.querySelectorAll(".titre-dark-js");
    const btnDarkMode = document.querySelector(".btn-dark-js");
    const backgroundDark = document.querySelector(".background-dark-js");
    const textDark = document.querySelectorAll(".texte-dark-js");

    btnDarkMode.addEventListener("click", function(){
        
        backgroundDark.classList.toggle("background-dark");
        titreDark.forEach(function(e){
            e.classList.toggle("titre-dark")}
        )
        textDark.forEach(function(e){
            e.classList.toggle("texte-dark");
        })
        btnDarkMode.classList.toggle("moonbackground");
    })


    const form = document.querySelector(".form-js");
    form.addEventListener("submit", function(e){
        e.preventDefault();
        window.alert("Votre adresse mail est bien validée");
    })
}
if (pageId === "article"){
    const menuToggle = document.querySelector(".menu__toggle");
    const menu = document.querySelector(".menu");
    

    const menuLinks= document.querySelectorAll(".menu__el a");

    if(menuToggle){
        menuToggle.addEventListener("click", menuOpen);

        for(let menuLink of menuLinks){
            menuLink.addEventListener("click", menuOpen);
        }
    }
    function menuOpen(){
        menu.classList.toggle("menu--open");
       // body.classList.toggle("no--scroll");

    }
        menu.classList.toggle("menu--open");

    const btnClose = document.querySelector(".btn-js");
    btnClose.addEventListener("click", onBtnClick);

    function onBtnClick(){
        const popup = document.querySelector(".popup-js");
        popup.classList.add("popup--close");

        const body = document.querySelector(".article-body");
        body.classList.remove("article-body--noscroll");
        }
}
if (pageId === "warning"){
    const msgError = document.querySelector(".warning-error");
    const btn = document.querySelector(".btn-js");

    const inputId = document.querySelector(".inputid-js");
    const inputMDP = document.querySelector(".inputmdp-js");

    btn.addEventListener("click", function(e){
        e.preventDefault();
        if (inputId.value === ""){
            msgError.innerHTML = "Identifiant requis";
        } else if (inputMDP.value === ""){
            msgError.innerHTML = "Mot de passe requis";
        } else {
            msgError.innerHTML = "Échec de l'authentification"
        }
        msgError.classList.add("opacity");
        msgError.addEventListener("animationend", function(){
            msgError.classList.remove("opacity");
        })
    })
}
if (pageId === "messages"){
    const btn = document.querySelector(".btn-js"); //btn-js c'est le bouton envoyer
    //const input = document.querySelector(".input-js");
    //const container = document.querySelector(".container-js");
    //const form = document.querySelector(".msg-form");
    btn.addEventListener("click", function(e){
        e.preventDefault();
        alert("Vous avez 2 message à signaler avant de pouvoir envoyer des messages");
    //    if(input.value !== ""){
    //        const div = document.createElement("div");
    //        div.classList.add("send-message");
    //        div.classList.add("msg-message");
    //        const p = document.createElement("p");
    //        p.innerText = input.value;   
    //        div.appendChild(p);
    //        container.appendChild(div);
    //        input.value = "";
    //        container.scrollTop = container.scrollHeight;
    //    } else{
    //        form.classList.add("msg-form--wrong");
    //        form.addEventListener("animationend", function(){
    //            form.classList.remove("msg-form--wrong");
    //        })
    //    }
    })

    const open = document.querySelector(".btn-open");
    const close = document.querySelector(".btn-close");
    const list = document.querySelector(".liste-js");
    const menuBoutons = document.querySelectorAll(".msg-nav__el");

    if(open){
        open.addEventListener("click", menuOpen);
        close.addEventListener("click", menuClose);

        for (let menuBouton of menuBoutons){
            menuBouton.addEventListener("click", onBtnClick);
        }
    }

    function menuOpen(){
        list.classList.toggle("msg-nav__container--open");
    }
    function menuClose(){
        list.classList.toggle("msg-nav__container--open");
    }
    function onBtnClick(){
        const btnActive = document.querySelector(".msg-nav__el--active");
        btnActive.classList.remove("msg-nav__el--active");
        this.classList.add("msg-nav__el--active");

        list.classList.toggle("msg-nav__container--open");
    }

    const leaveBtn = document.querySelectorAll(".leave-js");

    leaveBtn.forEach(function(e){
        e.addEventListener("click", clickBtnLeave);
    })

    function clickBtnLeave(){
        window.alert("Cette fonction n'est pas disponible, réessayez plus tard");
    }

    const tabLinks = document.querySelectorAll(".tab__el");
    if(tabLinks.length > 0){
    for (let tabLink of tabLinks) {
        tabLink.addEventListener("click", tabTrigger);
        }
    }
    function tabTrigger(e){
        e.preventDefault();

        const tabActive = document.querySelector(".section__content--active");
        tabActive.classList.remove("section__content--active");

        const tabLink = e.currentTarget.querySelector("a");
        const tabSelectID = tabLink.getAttribute("href");
        
        const tabSelect = document.querySelector(tabSelectID);
        tabSelect.classList.add("section__content--active");
    }
}
//if (pageId === "casestudy"){
//
//
//    const phrases = {
 //       1: "test",
 //       2: "Le test fonctionne",
 //       3: "Pour être sur"
//
//    };
//    //console.log(phrases[3])
//    const reset = document.querySelector(".reset");
//    const phraseContainer = document.querySelector(".phrase-container");
//
//    reset.addEventListener("click", onCLickBtn);
//    
//    function onCLickBtn(){
// phraseContainer.innerText = phrases [Math.floor(Math.random() * (3 - 1 + 1)) + 1];
//    }
//}